import React from "react";

function getInitials(name) {
  const parts = String(name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

function CustomerAvatar({ name }) {
  return (
    <div
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#F3F0FA] text-[13px] font-bold text-[#2E1834] sm:h-12 sm:w-12"
      aria-hidden
    >
      {getInitials(name)}
    </div>
  );
}

function StatRow({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-4 text-[13px]">
      <span className="text-[#9CA3AF]">{label}</span>
      <span className="text-right font-semibold tabular-nums text-[#1F2937]">
        {value}
      </span>
    </div>
  );
}

export function CustomerCard({ customer, onViewDetails }) {
  const subline = [customer.email, customer.location]
    .filter((s) => s && s !== "—")
    .join(" · ");

  return (
    <article className="rounded-xl border border-[#EFEFEF] bg-white p-4 sm:p-5">
      <div className="flex items-start gap-3">
        <CustomerAvatar name={customer.name} />
        <div className="min-w-0 flex-1 pt-0.5">
          <h3 className="my-0 truncate text-[15px] font-bold text-[#1F2937] sm:text-[16px]">
            {customer.name}
          </h3>
          {subline ? (
            <p className="my-0 mt-1 truncate text-[12px] text-[#9CA3AF] sm:text-[13px]">
              {subline}
            </p>
          ) : null}
        </div>
      </div>

      <div className="mt-4 space-y-2.5 border-t border-[#F3F4F6] pt-4">
        <StatRow label="Total Order" value={customer.totalOrders} />
        <StatRow label="Total Spent" value={customer.totalSpent} />
        <StatRow label="Last Order" value={customer.lastOrderLabel} />
      </div>

      <button
        type="button"
        onClick={() => onViewDetails?.(customer)}
        className="mt-4 w-full cursor-pointer rounded-xl border-0 bg-[#F8F8F8] py-3 text-[14px] font-semibold text-[#2E1834] transition-colors hover:bg-[#F3F4F6]"
      >
        View Details
      </button>
    </article>
  );
}
